import { FaTimes } from 'react-icons/fa'
import {} from 'react-query'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Box, BoxProps } from 'theme-ui'
import Footer from '../components/Footer/Footer'
import { HeaderComponent, SimpleHeader } from '../components/Header/Header'
import ScrollToTop from '../components/ScrollToTop'
import HomePage from '../pages/HomePage/HomePage'
import LandingPage from '../pages/LandingPage/LandingPage'
import CreateLaporanPengaduan from '../pages/LaporanPengaduan/CreateLaporanPengaduan'
import LaporanPengaduanDetail from '../pages/LaporanPengaduan/LaporanPengaduanDetail'
import ListArchivedLaporanPengaduan from '../pages/LaporanPengaduan/ListArchivedLaporanPengaduan'
import ViolationReportList from '../pages/LaporanPengaduan/ViolationReportLIst'
import LoginPage from '../pages/LoginPage/LoginPage'
import Sidebar from './Sidebar'
import useCurrentUserStore from '../stores/currentUser'
import LandingPageHeader from '../components/Header/LandingPageHeader'
import NotFound from '../pages/NotFound/NotFound'
import LandingPageRoutes from './LandingPageRoutes'
import UsersPage from '../pages/UsersPage/UsersPage'
import UserDetailPage from '../pages/UsersPage/UserDetailPage'
import CreateUserPage from '../pages/UsersPage/CreateUserPage'
import HandedOverList from '../pages/LaporanPengaduan/HandedOverList'

export default function Router() {
  const currentUser = useCurrentUserStore((s) => s.currentUser)
  const isAuthenticated = !!currentUser.authToken
  const role = currentUser?.data?.roles

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer
        hideProgressBar
        autoClose={1700}
        position={'top-right'}
        transition={Slide}
        toastClassName="mt-3"
        closeButton={<FaTimes />}
      />

      <Routes>
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <>
                <Routes>
                  <Route path="/*" element={<HeaderComponent />} />
                </Routes>

                <Routes>
                  <Route path="/*" element={<Sidebar />} />
                </Routes>

                <PageContainer>
                  <Routes>
                    <Route index element={<HomePage />} />
                    <Route
                      path="laporan-pengaduan/*"
                      element={<ReportRoutes />}
                    />
                    {role === 'superadmin' && (
                      <>
                        <Route path="users" element={<UsersPage />} />
                        <Route
                          path="users/create"
                          element={<CreateUserPage />}
                        />
                        <Route path="users/:id" element={<UserDetailPage />} />
                      </>
                    )}
                  </Routes>
                </PageContainer>

                <Routes>
                  <Route path="/*" element={<Footer />} />
                </Routes>
              </>
            ) : (
              <LandingPageRoutes />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

function ReportRoutes() {
  return (
    <PageContainer>
      <Routes>
        <Route path="create" element={<CreateLaporanPengaduan />} />
        <Route path=":id" element={<LaporanPengaduanDetail />} />
        <Route path=":id/edit" element={<LaporanPengaduanDetail />} />
        <Route path="archived" element={<ListArchivedLaporanPengaduan />} />
        <Route path="violation" element={<ViolationReportList />} />
        <Route path="handed-over" element={<HandedOverList />} />
      </Routes>
    </PageContainer>
  )
}

function PageContainer(props: BoxProps) {
  return (
    <Box
      sx={{ minHeight: '100vh', pl: ['unset', null, 60], pt: 70, pb: 15 }}
      {...props}
    />
  )
}
